export const superCodeState = state => ( { superCode: state.superCode } );
